import { NotificationsMenu } from "./blocks/NotificationsMenu";
import { useNotificationsMenu } from "../model/useNotificationsMenu";

export function NotificationTrigger() {
  const menu = useNotificationsMenu();

  return (
    <span className="relative inline-flex shrink-0">
      <NotificationsMenu {...menu} />
    </span>
  );
}
